<template>
  <div style="margin-left:-15px">
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div>
        <h5 class="mb-1">Banners da Transmissão</h5>
        <p class="text-muted mb-0" style="font-size: 13px;">
          Adicione até <strong>3 banners</strong> que serão exibidos em carrossel durante a transmissão ao vivo.
        </p>
      </div>
      <span class="badge badge-soft-primary px-3 py-2" style="font-size: 13px;">
        {{ banners.length }}/3
      </span>
    </div>

    <!-- Banners existentes -->
    <div v-if="banners.length > 0" class="mb-4">
      <div v-for="(banner, idx) in banners" :key="banner.id" class="card mb-3 border" style="border-radius: 10px; overflow: hidden;">
        <div class="row no-gutters align-items-center">
          <!-- Preview do banner -->
          <div class="col-md-5">
            <div style="position: relative; height: 120px; background: #f8f9fa;">
              <img
                :src="banner.url_image"
                class="w-100 h-100"
                style="object-fit: cover;"
              />
              <span
                class="badge badge-dark"
                style="position: absolute; top: 8px; left: 8px; font-size: 11px; opacity: 0.8;"
              >
                Banner {{ idx + 1 }}
              </span>
            </div>
          </div>
          <!-- Info e ações -->
          <div class="col-md-7">
            <div class="card-body py-3">
              <div class="form-group mb-2">
                <label class="mb-1" style="font-size: 12px; font-weight: 600; color: #6c757d;">
                  <i class="mdi mdi-link-variant mr-1"></i>Link de ação
                </label>
                <div class="input-group input-group-sm">
                  <input
                    v-model="banner.url_action"
                    type="text"
                    class="form-control"
                    placeholder="https://... (opcional)"
                    @blur="updateBanner(banner)"
                  />
                  <div class="input-group-append" v-if="banner.url_action">
                    <a :href="banner.url_action" target="_blank" class="btn btn-outline-secondary" title="Abrir link">
                      <i class="mdi mdi-open-in-new"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between mt-2">
                <small class="text-muted">
                  <i class="mdi mdi-image-outline mr-1"></i>Clique para trocar a imagem
                </small>
                <div>
                  <label :for="'replace-' + banner.id" class="btn btn-sm btn-outline-primary mb-0 mr-1" style="cursor: pointer;">
                    <i class="mdi mdi-image-edit-outline"></i> Trocar
                  </label>
                  <input
                    :id="'replace-' + banner.id"
                    type="file"
                    accept="image/*"
                    style="display: none;"
                    @change="replaceBannerImage(banner, $event)"
                  />
                  <button type="button" class="btn btn-sm btn-outline-danger" @click="removeBanner(banner.id)">
                    <i class="mdi mdi-trash-can-outline"></i> Remover
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dropzone para novo banner -->
    <div v-if="banners.length < 3">
      <div
        class="dropzone-area"
        :class="{ 'dropzone-hover': isDragging, 'dropzone-has-preview': preview }"
        @click="$refs.fileInput.click()"
        @dragover.prevent="isDragging = true"
        @dragleave.prevent="isDragging = false"
        @drop.prevent="onDrop"
      >
        <!-- Preview -->
        <div v-if="preview" style="position: relative; width: 100%; height: 100%;">
          <img :src="preview" class="w-100 h-100" style="object-fit: cover; border-radius: 10px;" />
          <div class="dropzone-overlay">
            <i class="mdi mdi-image-edit-outline" style="font-size: 24px;"></i>
            <span>Clique para trocar</span>
          </div>
        </div>
        <!-- Upload placeholder -->
        <div v-else class="text-center">
          <i class="mdi mdi-cloud-upload-outline" style="font-size: 40px; color: #556ee6; opacity: 0.7;"></i>
          <p class="mb-1 mt-2" style="font-size: 14px; font-weight: 500; color: #495057;">
            Arraste uma imagem ou clique para selecionar
          </p>
          <p class="mb-0" style="font-size: 12px; color: #adb5bd;">
            Recomendado: 728 x 90px (PNG, JPG) — máx. 3MB
          </p>
        </div>
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          style="display: none;"
          @change="onFileChange"
        />
      </div>

      <!-- Campos extras após selecionar imagem -->
      <div v-if="preview" class="mt-3">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label style="font-size: 13px; font-weight: 600;">
                <i class="mdi mdi-link-variant mr-1"></i>Link de ação
              </label>
              <input
                v-model="newBanner.url_action"
                type="text"
                class="form-control"
                placeholder="https://... (opcional)"
              />
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center" style="gap: 10px;">
          <button type="button" class="btn btn-primary" @click="addBanner()">
            <i class="mdi mdi-plus mr-1"></i> Adicionar Banner
          </button>
          <button type="button" class="btn btn-light" @click="cancelNew()">
            Cancelar
          </button>
        </div>
      </div>
    </div>

    <!-- Limite atingido -->
    <div v-else class="text-center py-4" style="background: #f8f9fa; border-radius: 10px; border: 2px dashed #dee2e6;">
      <i class="mdi mdi-check-circle-outline" style="font-size: 32px; color: #34c38f;"></i>
      <p class="mb-0 mt-2 text-muted" style="font-size: 14px;">Limite de 3 banners atingido</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  name: 'room-banners',
  data () {
    return {
      banners: [],
      newBanner: {
        photo: null,
        url_action: ''
      },
      preview: null,
      isDragging: false
    }
  },
  beforeMount () {
    this.loadBanners()
  },
  methods: {
    ...mapActions('roomBanner', {
      fetchBanners: 'getList',
      saveBanner: 'save',
      updateBannerAction: 'update',
      deleteBanner: 'remove'
    }),
    async loadBanners () {
      let loader = this.$loading.show()
      try {
        await this.fetchBanners(this.$route.params.id)
        this.banners = this.$store.getters['roomBanner/BANNERS']
      } catch (err) {
        errorMessage('Falha ao carregar banners')
      }
      loader.hide()
    },
    onFileChange (e) {
      const file = e.target.files[0]
      if (file) {
        if (file.size > 3 * 1024 * 1024) {
          errorMessage('A imagem deve ter no máximo 3MB')
          return
        }
        this.newBanner.photo = file
        this.preview = URL.createObjectURL(file)
      }
    },
    onDrop (e) {
      this.isDragging = false
      const file = e.dataTransfer.files[0]
      if (file && file.type.startsWith('image/')) {
        if (file.size > 3 * 1024 * 1024) {
          errorMessage('A imagem deve ter no máximo 3MB')
          return
        }
        this.newBanner.photo = file
        this.preview = URL.createObjectURL(file)
      }
    },
    cancelNew () {
      this.newBanner = { photo: null, url_action: '' }
      this.preview = null
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    },
    async addBanner () {
      if (!this.newBanner.photo) return

      let loader = this.$loading.show()
      try {
        const formData = new FormData()
        formData.append('photo', this.newBanner.photo)
        if (this.newBanner.url_action) {
          formData.append('url_action', this.newBanner.url_action)
        }

        await this.saveBanner({
          roomId: this.$route.params.id,
          formData
        })

        successMessage('Banner adicionado com sucesso.', 2500)
        this.cancelNew()
        await this.loadBanners()
      } catch (err) {
        errorMessage('Atenção: ' + (err.response?.data?.message || err.message))
      }
      loader.hide()
    },
    async replaceBannerImage (banner, event) {
      const file = event.target.files[0]
      if (!file) return

      if (file.size > 3 * 1024 * 1024) {
        errorMessage('A imagem deve ter no máximo 3MB')
        return
      }

      let loader = this.$loading.show()
      try {
        const formData = new FormData()
        formData.append('photo', file)
        if (banner.url_action) {
          formData.append('url_action', banner.url_action)
        }

        await this.updateBannerAction({
          roomId: this.$route.params.id,
          bannerId: banner.id,
          formData
        })

        successMessage('Imagem atualizada.', 2500)
        await this.loadBanners()
      } catch (err) {
        errorMessage('Falha ao atualizar imagem')
      }
      loader.hide()
    },
    async updateBanner (banner) {
      let loader = this.$loading.show()
      try {
        const formData = new FormData()
        formData.append('url_action', banner.url_action || '')

        await this.updateBannerAction({
          roomId: this.$route.params.id,
          bannerId: banner.id,
          formData
        })

        successMessage('Banner atualizado.', 2500)
      } catch (err) {
        errorMessage('Falha ao atualizar banner')
      }
      loader.hide()
    },
    async removeBanner (bannerId) {
      if (!confirm('Deseja remover este banner?')) return

      let loader = this.$loading.show()
      try {
        await this.deleteBanner({
          roomId: this.$route.params.id,
          bannerId
        })

        successMessage('Banner removido.', 2500)
        await this.loadBanners()
      } catch (err) {
        errorMessage('Falha ao remover banner')
      }
      loader.hide()
    }
  }
}
</script>

<style scoped>
.dropzone-area {
  border: 2px dashed #d4d9e1;
  border-radius: 10px;
  padding: 40px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafbfc;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 140px;
}

.dropzone-area:hover,
.dropzone-hover {
  border-color: #556ee6;
  background: #f0f3ff;
}

.dropzone-has-preview {
  padding: 0;
  height: 140px;
  overflow: hidden;
}

.dropzone-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  opacity: 0;
  transition: opacity 0.2s ease;
  font-size: 13px;
  gap: 4px;
}

.dropzone-has-preview:hover .dropzone-overlay {
  opacity: 1;
}

.badge-soft-primary {
  background: rgba(85, 110, 230, 0.1);
  color: #556ee6;
  font-weight: 600;
}
</style>
